import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material.module';
import { SignupComponent } from './auth/signup/signup.component';
import { LoginComponent } from './auth/login/login.component';
import { OrderComponent } from './order/order.component';
import { NewOrderComponent } from './order/new-order/new-order.component';
import { PastOrderComponent } from './order/past-order/past-order.component';
import { CurrentOrderComponent } from './order/current-order/current-order.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { AppRoutingModule } from './app-routing.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { ClientComponent } from './client/client.component';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HeaderComponent } from './navigation/header/header.component';
import { SidenavListComponent } from './navigation/sidenav-list/sidenav-list.component';
import { AuthService } from './auth/auth.service';
import { UIService } from './shared/ui.service';
import { OrderItemComponent } from './order/directives/order-item/order-item.component';
import { OrderDetailsComponent } from './order/order-details/order-details.component';
import { OpenCloseComponent } from './transitions/open-close.component';
import { GooglePlacesAutocompleteComponent } from './shared/google-places.component';
import { AgmCoreModule } from '@agm/core';
import { DashboardComponent } from './dashboard/dashboard.component';
import { CounterInputComponent } from './shared/test-counter.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { InvoiceDetailsComponent } from './invoice/invoice-details/invoice-details.component';
import { ProfileComponent } from './profile/profile.component';
import { ReservationComponent } from './reservation/reservation.component';
import { ReservationDetailsComponent } from './reservation/details/reservation-details/reservation-details.component';
import { DeliveryComponent } from './order/delivery/delivery.component';
import { DeliveryDetailsComponent } from './order/delivery/delivery-details/delivery-details.component';
import { OnSiteComponent } from './order/on-site/on-site.component';
import { OnSiteDetailsComponent } from './order/on-site/on-site-details/on-site-details.component';
import { PickupDetailsComponent } from './order/pickup/pickup-details/pickup-details.component';
import { PickupComponent } from './order/pickup/pickup.component';
import { FooterComponent } from './navigation/footer/footer.component';
import { SetForPickupComponent } from './order/on-site/dialog/set-for-pickup/set-for-pickup.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { MustFillProfileComponent } from './reservation/dialog/must-fill-profile/must-fill-profile.component';
import { SetForSwitchComponent } from './order/on-site/dialog/set-for-switch/set-for-switch.component';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { NeedASwitchComponent } from './reservation/dialog/need-a-switch/need-a-switch.component';
import { PicturesComponent } from './invoice/invoice-details/dialog/pictures/pictures.component';
import { GlobalPubSub } from './shared/global-sub-pub.service';
import { MonerisComponent } from './moneris/moneris.component';
import { AccessComponent } from './access/access.component';
import { AccessDetailsComponent } from './access/dialog/access-details/access-details.component';
import { AccessInvitationComponent } from './access/dialog/access-invitation/access-invitation.component';
import { InvoiceV2Component } from './invoice-v2/invoice-v2.component';
import { OrderInvoiceListComponent } from './invoice-v2/order-invoice-list/order-invoice-list.component';
import { OrderInvoiceDetailComponent } from './invoice-v2/order-invoice-detail/order-invoice-detail.component';
import { PhoneMaskDirective } from './shared/validators/phone-mask.directive';
import { PricesComponent } from './shared/prices/prices.component';



// the second parameter 'fr' is optional
registerLocaleData(localeFr, 'fr');

@NgModule({
  declarations: [
    AppComponent,
    SignupComponent,
    LoginComponent,
    OrderComponent,
    NewOrderComponent,
    PastOrderComponent,
    CurrentOrderComponent,
    WelcomeComponent,
    ClientComponent,
    HeaderComponent,
    SidenavListComponent,
    OrderItemComponent,
    OrderDetailsComponent,
    OpenCloseComponent,
    GooglePlacesAutocompleteComponent,
    DashboardComponent,
    CounterInputComponent,
    InvoiceComponent,
    InvoiceDetailsComponent,
    ProfileComponent,
    ReservationComponent,
    ReservationDetailsComponent,
    DeliveryComponent,
    DeliveryDetailsComponent,
    OnSiteComponent,
    OnSiteDetailsComponent,
    PickupDetailsComponent,
    PickupComponent,
    FooterComponent,
    SetForPickupComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    MustFillProfileComponent,
    SetForSwitchComponent,
    NeedASwitchComponent,
    PicturesComponent,
    MonerisComponent,
    AccessComponent,
    AccessDetailsComponent,
    AccessInvitationComponent,
    InvoiceV2Component,
    OrderInvoiceListComponent,
    OrderInvoiceDetailComponent,
    PhoneMaskDirective,
    PricesComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MaterialModule,
    AppRoutingModule,
    FlexLayoutModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    NgbModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCGRIprQiIHwUcaStZUbbKH45R6xSAFb3c',
      libraries: ['places']
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  exports: [
    PhoneMaskDirective
  ],
  providers: [AuthService, UIService, GlobalPubSub],
  bootstrap: [AppComponent],
  entryComponents: [
    SetForPickupComponent,
    MustFillProfileComponent,
    SetForSwitchComponent,
    NeedASwitchComponent,
    PicturesComponent,
    AccessDetailsComponent,
    AccessInvitationComponent
  ]
})
export class AppModule {
}
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}
